var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgListNowIcon = function SvgListNowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#listNowIcon_svg__a)",
    d: "M0 4a4 4 0 0 1 4-4h32a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.779 8.194c-.165.107-.436.417-.59.68-.235.428-.27.643-.27 1.8 0 1.12.035 1.382.259 1.8.495.941 1.59 1.335 2.533.905.754-.333 1.343-1.263 1.626-2.55.188-.835.011-1.586-.46-2.04-.719-.703-2.415-1.025-3.098-.595"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.171 9.302c-1.272.632-2.945 2.087-6.75 5.901-1.509 1.502-2.793 2.766-2.863 2.778-.06.024-.283-.06-.495-.19-.2-.132-.884-.537-1.496-.919-3.205-1.979-5.09-2.706-5.42-2.098-.153.31-.153 1.371.012 1.908.389 1.275 1.685 3.528 2.969 5.126.389.488.707.953.707 1.013 0 .071-.613 1.049-1.367 2.17-2.498 3.743-3.805 6.39-3.393 6.89.2.25 1.06.095 2.191-.37 1.131-.476 3.335-1.62 3.97-2.074.166-.13.342-.226.378-.226s.294-.167.565-.358c.283-.203.79-.56 1.143-.787.353-.238.719-.5.801-.596.224-.226.26-.214.742.108.966.667 3.158 1.835 4.43 2.36 2.592 1.085 4.748 1.657 6.173 1.657 1.108 0 1.532-.131 1.532-.489 0-.37-.507-1.323-1.143-2.17-.671-.894-4.453-4.72-5.726-5.805-.494-.417-.907-.835-.907-.906 0-.084.212-.5.472-.93 1.201-1.99 3.322-6.45 4.158-8.714.425-1.157.672-2.206.672-2.85 0-.488-.035-.572-.306-.667-.366-.143-.212-.179-1.049.238"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "listNowIcon_svg__a",
    x1: 0,
    x2: 40,
    y1: 0,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E8ECC"
  })))));
};
export { SvgListNowIcon as ReactComponent };